package com.essntl.features.address.data.supabase

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SetPlaceDto(
    @SerialName("address_id")
    val addressId: String,
)
